export default function AGB() {
    return (
        <div data-testid="page-agb" className="pt-16 md:pt-24 pb-24">
            <div className="max-w-[900px] mx-auto px-6 md:px-12 lg:px-16">
                <p className="overline mb-6">Rechtliches</p>
                <h1 className="font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95] font-medium text-ink mb-4">
                    Allgemeine Geschäftsbedingungen
                </h1>
                <p className="font-body text-sm text-inkSoft mb-12">
                    Mein Schuster · Weichser Weg 5 · 93059 Regensburg · Donau-Einkaufszentrum (DEZ)
                </p>

                <div className="prose prose-neutral max-w-none font-body text-[15px] leading-relaxed text-ink space-y-8">
                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 1 Geltungsbereich</h2>
                        <p>
                            Für alle Aufträge, Lieferungen und sonstigen Leistungen der Firma
                            Mein Schuster (nachfolgend „Auftragnehmer") gelten ausschließlich
                            diese Allgemeinen Geschäftsbedingungen. Entgegenstehende oder
                            abweichende Bedingungen des Auftraggebers werden nicht anerkannt,
                            es sei denn, der Auftragnehmer stimmt ihnen ausdrücklich
                            schriftlich zu.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 2 Vertragsschluss</h2>
                        <p>
                            Der Vertrag kommt durch die Annahme des Auftrages durch den
                            Auftragnehmer zustande. Dies erfolgt in der Regel durch
                            persönliche Abgabe des Reparaturgegenstandes im Geschäftslokal
                            und Ausstellung eines Auftragsbelegs.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 3 Preise und Zahlungsbedingungen</h2>
                        <p>
                            Alle genannten Preise verstehen sich in Euro und inklusive der
                            gesetzlichen Mehrwertsteuer. Die Zahlung erfolgt bei Abholung
                            der Ware in bar, per EC-Karte oder Kreditkarte. Der
                            Auftragnehmer behält sich das Eigentum an der reparierten Ware
                            bis zur vollständigen Zahlung des Entgelts vor.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 4 Leistungsumfang</h2>
                        <p>
                            Art und Umfang der zu erbringenden Leistungen ergeben sich aus
                            dem Auftragsbeleg. Der Auftragnehmer ist berechtigt, die
                            ausgeschriebenen Leistungen durch Dritte ausführen zu lassen.
                            Mehraufwendungen, die sich erst während der Reparatur zeigen,
                            werden dem Auftraggeber mitgeteilt und separat abgerechnet.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 5 Lieferzeiten und Abholung</h2>
                        <p>
                            Angegebene Fertigstellungstermine sind, sofern nicht ausdrücklich
                            anders vereinbart, unverbindlich. Nach Fertigstellung ist der
                            Auftraggeber verpflichtet, die Ware innerhalb von 30 Tagen
                            abzuholen. Nach Ablauf dieser Frist kann der Auftragnehmer
                            angemessene Lagergebühren berechnen. Wird die Ware nach 6
                            Monaten nicht abgeholt, ist der Auftragnehmer berechtigt, diese
                            zur Deckung seiner Kosten zu verwerten.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 6 Gewährleistung</h2>
                        <p>
                            Die gesetzlichen Gewährleistungsrechte bleiben unberührt. Offene
                            Mängel sind unverzüglich, spätestens jedoch innerhalb von 14
                            Tagen nach Abholung schriftlich oder persönlich anzuzeigen.
                            Keine Gewährleistung wird übernommen für Mängel, die auf
                            natürliche Abnutzung, unsachgemäße Behandlung oder bereits
                            bestehende Vorschäden zurückzuführen sind.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 7 Haftung</h2>
                        <p>
                            Der Auftragnehmer haftet für Vorsatz und grobe Fahrlässigkeit
                            nach den gesetzlichen Bestimmungen. Für leichte Fahrlässigkeit
                            ist die Haftung auf den typischerweise vorhersehbaren Schaden
                            begrenzt. Für besonders wertvolle Gegenstände (Wert über 500 €)
                            haftet der Auftragnehmer nur, wenn der Wert bei Auftragserteilung
                            ausdrücklich mitgeteilt wurde.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 8 Schlüsseldienst und Autoschlüssel</h2>
                        <p>
                            Bei der Anfertigung von Schlüsseln, insbesondere Sicherheits-
                            und Autoschlüsseln, ist der Auftraggeber verpflichtet, die
                            Berechtigung zum Besitz des Originalschlüssels nachzuweisen
                            (z. B. Sicherungskarte, Fahrzeugschein, Personalausweis). Für
                            Folgen einer wahrheitswidrigen Angabe haftet der Auftraggeber
                            allein.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 9 Datenschutz</h2>
                        <p>
                            Personenbezogene Daten werden ausschließlich zur
                            Auftragsabwicklung gespeichert und nicht an Dritte weitergegeben.
                            Weitere Informationen finden sich in der gesonderten
                            Datenschutzerklärung.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">§ 10 Schlussbestimmungen</h2>
                        <p>
                            Es gilt das Recht der Bundesrepublik Deutschland. Erfüllungsort
                            und, soweit gesetzlich zulässig, Gerichtsstand ist Regensburg.
                            Sollte eine Bestimmung dieser AGB unwirksam sein oder werden,
                            bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.
                        </p>
                    </section>

                    <p className="text-xs text-inkSoft pt-8 border-t border-line">
                        Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}.
                        Dieser Text ist ein Muster-Entwurf. Vor Veröffentlichung wird eine
                        rechtliche Prüfung durch einen Anwalt oder die IHK Regensburg empfohlen.
                    </p>
                </div>
            </div>
        </div>
    );
}
